<template>
  <div class="shopPopup-layer" v-if="isShowPopup">
    <div class="content-wrap" @click="closePopup">
      <a
        class="btn-item btn-close"
        href="javascript: void(0)"
        @click="closePopup"
      ></a>
    </div>
  </div>
</template>

<script>
// import Cookies from 'js-cookie'
export default {
  name: "ShopPopup",
  data() {
    return {
      isShowPopup: false,
      // link: "/rewardpc/member/shop/index?hmsr=pc&hmpl=&hmcu=memberday&hmci=popup&hmkw=Mar"
    };
  },
  mounted () {
    this.checkPopup();
  },
  methods: {
    checkPopup () {
      // 2021-03-29 弹窗下线

      // if (!this.$store.state.user || !this.$store.state.user.token) {
      //   return;
      // }
      // const hasPopup = Cookies.get('REWARD_SHOP_POPUP_PC_1')
      // if (!hasPopup) {
      //   this.isShowPopup = true
      //   var curDate = new Date();
      //   var curTamp = curDate.getTime();
      //   var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
      //   var passedTamp = curTamp - curWeeHours;
      //   var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
      //   var leftTime = new Date();
      //   leftTime.setTime(leftTamp + curTamp);
      //   document.cookie = "REWARD_SHOP_POPUP_PC_1=1;path=/;expires=" + leftTime.toGMTString();
      // }
    },
    closePopup() {
      this.isShowPopup = false;
    },
  },
};
</script>

<style lang="less" scoped>
.shopPopup-layer {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  .content-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 723px;
    height: 483px;
    background: url("https://resource.rcclchina.com.cn/reward/20210317popup/PC-720-480.jpg") no-repeat;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    cursor: pointer;
    .btn-close {
      position: absolute;
      right: 0;
      top: -40px;
      width: 40px;
      height: 40px;
      background: url("../../assets/images/close.png") no-repeat center center;
      background-size: 26px 26px;
    }
  }
}
</style>